import { Text, type TextProps } from "@mantine/core"
import { valueToThemeColor } from "../surveys"
import classes from "./Score.module.css"

export function Score({
  size,
  value,
  text,
  base = 10,
  shade = 5,
  rate = true,
  fixed = true,
  ...props
}: {
  value?: number | null
  size?: string | number
  base?: number
  rate?: boolean
  fixed?: boolean
  text?: boolean
  shade?: number
} & TextProps) {
  const baseValue = (value || 0) * (base / 100)
  const haveValue = value !== null && value !== undefined
  const color = haveValue && rate ? valueToThemeColor(value) : "blue"
  const displayValue = haveValue ? (fixed ? baseValue.toFixed(1) : baseValue) : "–"

  if (text)
    return (
      <Text span fw={700} fz={size || "xl"} c={`${color}.9`} {...props}>
        {displayValue}
      </Text>
    )

  return (
    <Text
      c={haveValue ? "white" : "gray.5"}
      style={{
        "--score-size": size || undefined,
        "--score-background": haveValue
          ? `linear-gradient(45deg, var(--mantine-color-${color}-${shade}) 0%, var(--mantine-color-${color}-${shade - 2}) 100%)`
          : undefined,
      }}
      classNames={classes}
      {...props}
    >
      {displayValue}
    </Text>
  )
}
